module.exports = __webpack_public_path__ + "img/c-class-sport.6102321b.jpg";